import { StepsButtons } from "@/components/button/steps-button";
import { useStepRouteInfo } from "@/hooks/use-step-route-info";
import { IonSkeletonText } from "@ionic/react";
import ActivityLevelSelectionList from "../../components/activity-level-selection-list";
import { AnimatedOnboardingContainer } from "../../components/animated-onboarding-container";
import { useActivityLevel } from "../../hooks/use-activity-level";
import { setMixpanelOnboardingEvent } from "../../utils/mixpanel-onboarding";
import { setSmartlookOnboardingEvent } from "../../utils/smartlook-onboarding";

export default function OnboardingActivityLevel() {
  const { info, navigateToNextStep } = useStepRouteInfo();

  const {
    handleActivityLevelSelect,
    handleSubmit,
    isLoading,
    options,
    selectedActivityLevel,
    isUpdating,
  } = useActivityLevel({
    onSuccess: () => {
      setSmartlookOnboardingEvent({
        type: "submit",
        stepPath: info?.path,
      });
      setMixpanelOnboardingEvent({
        type: "submit",
        stepPath: info?.path,
      });
      navigateToNextStep();
    },
  });

  if (isLoading) {
    return (
      <AnimatedOnboardingContainer
        title="How active are you?"
        classNames={{
          container: "flex-1 h-full flex flex-col",
          form: "flex-1 flex flex-col",
        }}
      >
        <div className="flex w-full flex-1 flex-col justify-center gap-8">
          <IonSkeletonText animated className="h-20 rounded-xl" />
          <IonSkeletonText animated className="h-20 rounded-xl" />
          <StepsButtons type="button" disabled={true} />
        </div>
      </AnimatedOnboardingContainer>
    );
  }

  return (
    <AnimatedOnboardingContainer
      title="How active are you?"
      classNames={{
        container: "flex-1 h-full flex flex-col",
        form: "flex-1 flex flex-col overflow-y-scroll no-scrollbar gap-8",
      }}
    >
      <div className="flex w-full flex-1 flex-col justify-center gap-8">
        <div className="flex w-full flex-1 flex-col gap-3">
          <ActivityLevelSelectionList
            options={options}
            selectedActivityLevel={selectedActivityLevel}
            handleActivityLevelSelect={handleActivityLevelSelect}
          />
        </div>

        <StepsButtons
          type="button"
          disabled={isLoading || isUpdating || !selectedActivityLevel}
          onClick={handleSubmit}
        />
      </div>
    </AnimatedOnboardingContainer>
  );
}
